export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "en-US",
    "Messages": {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "${form.variants > 1 ? 'Generuj obrazy' : 'Generuj obraz'}": "${form.variants > 1 ? 'Generate images' : 'Generate image'}",
        "AI": "AI",
        "AI CMS": "AI CMS",
        "Anuluj": "Cancel",
        "Asystenta AI": "AI Assistant",
        "Błąd podczas generowania instrukcji": "Error while generating instruction",
        "Błąd podczas generowania metadanych SEO": "Error while generating SEO metadata",
        "Błąd podczas generowania opisu produktu": "Error while generating product description",
        "Brak kontekstu": "No context",
        "Brak produktu": "No product",
        "Brak zdefiniowanego klucza API dla dostawcy ${AiProviders.OPENAI}": "No API key defined for provider ${AiProviders.OPENAI}",
        "Format obrazu": "Image format",
        "Generator": "Generator",
        "Generator metadanych SEO": "SEO metadata generator",
        "Generator obrazów AI": "AI image generator",
        "Generowanie obrazów zakończone": "Image generation completed",
        "Generuj metadane": "Generate metadata",
        "Generuj obraz": "Generate image",
        "Generuj opis": "Generate description",
        "Generuj opis produktu": "Generate product description",
        "Konfiguracja AI": "AI configuration",
        "Konfiguracja asystenta ai": "AI assistant configuration",
        "Liczba wariantów": "Number of variants",
        "Nie udało się wygenerować promptu": "Failed to generate prompt",
        "Nieobsługiwany provider": "Unsupported provider",
        "Obraz został pomyślnie opisany": "Image has been described successfully",
        "Obrazy zostały przeniesione.": "Images have been moved.",
        "Opis został wygenerowany": "Description has been generated",
        "Proporcje obrazu": "Image aspect ratio",
        "Przejdź do konfiguracji, aby włączyć inteligentne narzędzia.": "Go to configuration to enable intelligent tools.",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "Go to configuration to enable tools",
        "Repozytorium plików": "File repository",
        "Ścieżka zapisu została zmieniona.": "Save path has been changed.",
        "Trwa generowanie obrazów": "Image generation in progress",
        "Trwa generowanie opisu": "Description generation in progress",
        "Trwa generowanie opisu dla wybranego obrazu": "Generating description for selected image",
        "Ustaw ścieżkę": "Set path",
        "Ustawienia (opcjonalne)": "Settings (optional)",
        "Użyj wyszukiwarki": "Use search engine",
        "Wybierz katalog do którego chcesz przenieść wybrane elementy.": "Select directory where you want to move selected items.",
        "Wybierz ścieżkę zapisu": "Select save path",
        "Wybróbuj możliwości AI": "Try AI capabilities",
        "Wygeneruj obraz z treści artykułu": "Generate image from article content",
        "Wypróbuj możliwości AI": "Try AI capabilities",
        "Wystąpił problem podczas przesyłania obrazu.": "A problem occurred while uploading image.",
        "Zamknij": "Close",
        "Zapisywanie obrazów zakończone.": "Saving images completed.",
        "Zapisywanie obrazów...": "Saving images...",
        "Zapisz": "Save",
        "Zapisz wybrane": "Save selected",
        "Zmień ścieżkę zapisu": "Change save path"
    }
};
